export default {
	'common':{
		'select':'Auswählen',
		'graph_loading': "Daten werden geladen...",
		'month_Names': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_day_name': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		'graph_export': "Exportieren",
		'graph_printButt': "Drucken",
		'graph_down_PNG': "Download als PNG-Bild",
		'graph_down_JPG': "Download als JPEG-Bild",
		'graph_down_PDF': "Download als PDF-Dokument",
		'graph_down_SVG': "Download als SVG-Bild",
		'graph_zoom_reset': "Zoom zurücksetzen",
		'Valid request.': 'gültige Anfrage.',
		'Warning': 'Warnung',
	},
	'main':{
		'titleStatistics':'Statistiken',
		'titleManual':'Benutzerhandbuch',
		'titleDownload':'Download',
		'titleArchives':'Archive',
		'titleStream':'Stream',
		'titleRealtime':'Echtzeit',
		'titlePlay':'Start',
		'titleDanger': 'Fehler/Messung gestoppt',
		'titleWarning': 'Im Betrieb',
		'titleSettings':'Einstellungen',
		'titleSD':'SD frei:',
		'titleHDD':'SSD frei:',
		'titleCamera': 'Kamera:',
		'titleLogout': 'Abmelden',
		'status':'Status',
		'error':'Fehler',
		'running':'Im Betrieb',
		'notRunning': 'Messung gestoppt',
		'downloadingFile':'Datei heruntergeladen',
		'preparingFile':'Datei wird vorbereitet'
	},
	'login':{
		'Username':'Benutzername',
		'Password':'Passwort',
		'Login':'Anmelden',
	},
	'dashboard':{
		'measuringTgl':'Messung',
		'noiseTgl':'Pegel',
		'weatherTgl':'Wetter',
		'adioTgl':'ADIO',
	},
	'graphs':{
		'export':{
			'Print chart':'Grafik downloaden',
			'Download':'Download',
			'image':'Bild',
		},
		'nodata': "KEINE DATEN",
		'errNoise': "Problem mit Nor140",
		'errWeath': "Problem mit Wetterstation",
		'errAdio': "Problem mit ADIO",
		'NOISE':'Pegel',
		'SPECTRUM':'Spektrum',
		'WEATHER':'Wetter',
		'ADIO': 'ADIO',
		'STATISTICS':'Statistik',
		'statTitle':'Titel',
		'statFrom':'Von',
		'statTo':'Bis',
		'load':'Laden',
		'markers':'Marker',
	    'dailyNotes': 'Tägliche Notizen',
	    'preload': 'Grafik manualladen',
	    'sync': 'Grafik synchrosieren',
	    'reset': 'Zoom zurücksetzen',
	    'exportGraph': 'Grafik exportieren',
	    'hideShow': 'Verbergen / Anzeigen',
		'markersCat':{
			'type':'Type',
			'color':'Farbe',
			'single': 'Punkt',
			'toggle': 'Bereich',
			'keybind': 'Tastenkombination',
			'learn':'Lernen',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete':'Löschen',
			'save': 'Speichern',
			'note':'Notizen',
		},
		'markersTable':{
			'name':'Name',
			'startTime': 'Start Zeit',
			'endTime': 'Stop Zeit',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'Kalender',
		'noise':'Pegel',
		'audio':'Audio',
		'weather':'Wetter',
		'video':'Video',
		'adio':'ADIO',
	},
	'streamPopover':{
		'title':'Streams',
		'Audio':'Audio',
		'Video':'Video',
		'StartManRec': 'Manuelle Aufzeichnung',
		'StopManRec': 'Aufzeichnung beenden',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop Stream',
	},
	'download':{
		'title':'Downloads',
		'popOver':{
			'XML':'Export XML Daten',
			'XMLWeekly':'Export wöchentliche XML Daten',
			'Raw':'Rohdaten',
			'Global':'Global Werte',
			'weather':'TXT Wetter',
		}
	},
	'archives':{
		'popOver':{
			'Global':'Global Werte',
			'Noise':'Pegel',
			'Audio':'Audio',
			'Video':'Video',
			'Weather':'Wetter',
			'Adio': 'ADIO',
			'Compressed': 'Komprimiert',
		},
		'audioPopOver':{
			'downlRec': 'Download Aufzeichnung',
			'range': 'Messbereich',
		},
		'video':'Video',
		'global':'Global Werte',
		'weather':'Wetter',
		'noise':'Pegel',
		'audio':'Audio',
		'name':'Archive',
		'Delete':'Löschen',
		'Download':'Download',
		'NorReview':'NorReview',
		'Thumbnail':'Bild',
		'Filename':'Dateiname',
		'Duration':'Dauer',
		'Size':'Größe',
		'Close':'Schließen',
		'adio': 'ADIO',	
		'compressed': 'KOMPRIMIERTE DATEIEN',
	}, 
	'settings':{
		'name':'Einstellungen',
		'save':'Speichern',
		'addButt': "Hinzufügen",
		'preTrigg': 'Vor-Trigger',
		'Trigg': 'Trigger',
		'postTrigg':'Nach-Trigger',
		'warning': 'Warnung',
		'continue': 'Weiter',
		'cancel': 'Abbrechen',

		'interface':{
			'settingsName':'Ansicht',
			'Realtime display':'Echtzeitanzeige [sec]',
			'Language':'Sprache',
			'Lt':'Pegelschrieb-Messbereich',
			'Spectrum':'Spektrum-Messbereich',
			'Weather':'Wetter-Messbereich',
			'Adio': 'ADIO-Messbereich',
			'Manual':'Manueller Messbereich',
			'Dynamic':'Automatischer Messbereich',
			'noiseTriggerLevel':'Triggerschwelle im Pegelschrieb anzeigen',
			'spectrumTriggerLevel':'Triggerschwelle im Spektrum anzeigen',
			//Options
			'english':'Englisch (EN)',
			'austria':'Deutsch (AT)',
			'german':'Deutsch (DE)',
			'french':'Französisch (FR)',
			'slovensko':'Slowenisch (SLO)',
		},
		'download':{
			'settingsName':'Download',
			'Compression':'Komprimierung',
			'No compression':'Keine Komprimierung',
			'Zip compression':'Zip-Komprimierung (Datenvolumen sparen)',
			'Noise':'Pegel',
			'Weather':'Wetter',
			'Global Values':'Global Werte',
			'Special values':'Spezial Funktionen',
			'Audio':'Audio',
			'Video':'Video',
			'Markers':'Markers',
			'Statistics':'Statistik',
			'statisticsTemplate':'Vorlage',
			'statisticsRename':"Vorlage umbenennen"
		},
		'audioRecording':{
			'settingsName':'Audio Aufzeichnung',
			'Format':'Format',
			'Audio Offset':'Audio Vor-Trigger [sec]',
			'Day':'Tag',
			'Night':'Nacht',
			'Optional 1':'Optional 1',
			'Optional 2':'Optional 2',
			'RecDur':'Aufzeichnungsdauer [sec]',
			'Threshold':'Überschreitungspegel [dBA]',
			'Start':'Start Zeit [HH]',
			'Stop':'Stop Zeit [HH]',
			'Weather':'Wetter Trigger',
			'Windspeed':'Windgeschwindigkeit',
			'Temperature':'Temperatur',
			'Air':'Luftdruck',
			'Precipitation':'Niederschlag',
			'Humidity':'Feuchtigkeit',
			//Options
			'Disable':'Deaktiviert',
			'Lower':'Kleiner als',
			'Greater':'Größer als',
			'Both':'Gleich',
			'lowerThan':'Kleiner als',
			'greaterThan':'Größer als',
		},
		'dynamicDns':{
			'settingsName':'Dynamic Dns',
			'Address':'Adresse',
			'Provider':'Provider',
			'Username':'Benutzername',
			'Password':'Passwort',
			'IP':'IP',
		},
		'alertMessaging':{
			'settingsName':'Alarm Meldung',
			'createGroupButton':'Neue Gruppe erstellen',
			'createGroupDialog':'Möchten Sie wirklich eine neue Gruppe erstellen?',
			'deleteGroupDialog':'Bestätigen Sie hier die Löschung von Gruppe ',
			'deleteEmailDialog':'Möchten Sie wirklich diese E-Mail/Mobilnummer löschen?',
			'dialogConfirm':'Bestätigen',
			'dialogContinue':'Weiter',
			'dialogCancel':'Abbrechen',
			'MSISDN-E-Mail':'Zu welcher/n Gruppe(n) möchten Sie den Empfänger hinzufügen?',
			'Add MSISDN':'Mobilnummer hinzufügen',
			'Add E-mail':'E-Mail Adresse hinzufügen',
			'DeleteButton': 'Löschen',
			'DeleteGroup':'Gruppe löschen',
			'DeleteRecip': 'Empfänger löschen',
			'DeleteEmail':'E-Mail/Mobilnummer löschen',
			'TestEmail':'Test E-Mail/SMS senden',
			'Resend after':'Erneut senden nach',
			'Threshold day':'Überschreitung Tag',
			'Threshold Night':'Überschreitung Nacht',
			'Threshold Opt 1':'Überschreitung Opt. 1',
			'Threshold Opt 2':'Überschreitung Opt. 2',
			'Running Average Level':'Running Average Level',
			'Weather trigger': 'Überschreitung Wetter',
			'System reboot':'System neu starten',
			'Connection with meter lost':'Verbindung zum Nor140 verloren',
			'FTP server error':'FTP-Server Fehler',
			'Critical memory on meter':'Kritischer Speicherplatz Nor140 (SD-Karte)',
			'Critical disk space':'Kritischer Speicherplatz SSD',
			'Microphone check error':'Mikrofon Check Fehler',
			'Battery mode':'Batteriemodus',
			'Connection with Weather station lost':'Verbindung zur Wetterstation verloren',
			'LEQ':'Leq Tag',
			'Inbound (MSISDN)':'Anfragen per SMS:',
			'Status':'Status',
			'GPS':'GPS:',
			'Threshold change':'Überschreitungspegel ändern:',
			'Email settings':'E-Mail Einstellungen',
			'Sender Email':'Absender E-Mail',
			'Password':'Passwort',
			'SMTP server':'SMTP Server',
			'SMTP port':'SMTP Port',
			'noRepeat':'Keine Wiederholung',
			'resendAft':'Erneut senden nach',
			//Options
			'min':'Min',
			'disabled':'Deaktivieren',
			'groupsError':'Bitte wählen Sie die Gruppen aus!',
			'emailSent':'Nachricht gesendet'
		},
		'FTPSending':{
			'settingsName':'FTP',
			'FTP Address':'FTP-Adresse',
			'Refresh Rate':'Aktualisierungsrate',
			'Username':'Benutzername',
			'Password':'Passwort',
			'Port':'Port',
			'Values':'Messwerte',
			//Options
			'Disable':'Deaktivieren',
			'sec':'Sek.',
			'min':'Min.',
			'hour':'Stunde',
			'measur':'Pegel',
			'weath':'Wetter',
			'audio':'Audio',
			'global':'Global Werte',
			'video':'Video',
		},
		'geographicPosition':{
		'settingsName':'Geografische Position',
			'Latitude': 'Geografische Breite [°]',
			'Longitude':'Geografische Länge [°]',
			'Height':'Höhe [m]',
		},
		'weather':{
			'settingsName':'Wetter',
			'Weather':'Wetterstation',
			'values':'Messwerte',
			'SetDevice':'Wetterstation auswählen',
			//Options
			'NoWeather':'Keine Wetterstation',
			'reinhardt':'Reinhardt MWS 5MV',
			'reinhardtRain':'Reinhardt MWS 5MV mit Regen',
			'thiesClima':'Thies Clima Sensor US',
			'vaisala':'Vaisala WXT520',
			'kw360': 'ONWA KW-360',
		},
		'delete':{
			'settingsName':'Löschen/Kompresse',
			'autoDelete':'Automatisch löschen älter als',
			'autoCompress':'Automatisch komprimieren älter als',
			'Disable':'Deaktivieren',
			'Manual delete':'Manuel löschen',
			'Values':'Messwerte',
			'Delete':'Löschen',
			//Options
			'day':'Tag(e)',
			'week':'Woche(n)',
			'month':'Monat(e)',
			'measur':'Pegel',
			'weath':'Wetter',
			'audio':'Audio',
			'global':'Global Werte',
			'logs':'Logs',
			'statistics':'Statistiken',
			'video':'Video',
			'adio': 'ADIO'
		},
		'device':{
			'settingsName':'Nor140',
			'Selection':'Mikrofon',
			'Polarisation':'Polarisationsspannung',
			'Frequency':'Frequenz Modus',
			'Resolution':'Auflösung',
			'Duration':'Messdauer',
			'Meter':'Nor140 Messbereich',
			'Values':'Messwerte',
			'Special':'Spezial Parameter',
			'Advance':'Weitere Einstellungen',
			'Mic check':'Mik. Check Pegel [dB]:',
			'Mic check time':'Mik. Check um [HH]:',
			'SDFreeSpace':'Meldung freier Speicherplatz SD-Karte [%]',
			'Restart':'Nor140 neu starten',
			'Set instrument':'Nor140 einstellen',
			'Format':'SD-Karte formatieren',
			'CheckSD':'Freier Speicherplatz SD-Karte prüfen',
			'formatSDdialog':'Die Formatierung kann bis zu 5 Minuten dauern, möchten Sie wirklich fortfahren?',
			'decrease':'Lautstärke erhöhen',
			'increase':'Lautstärke verringern',
			'value':'Messwerte',
			'threshold':'Überschreitungspegel (dBA)',
			'timeControlled':'Zeitgesteuert',
			'measurementControlled':'Messgesteuert',
			'start_stop':'Start Zeit/Stop Zeit',
			'startTime':'Start Zeit',
			'endTime':'Endzeit',
			'trigger':'Trigger',
			'duration':'Messdauer',
			'test':'Überprüfen',
			'testOpt': 'Überprüfen der installierten Optionen',
			'restartNoise':'Nor140 neu starten',
			'increasedVol': 'Lautstärke verringert',
			'decreasedVol': 'Lautstärke erhöht',
			'autostart': 'Auto Start-Stop',
			//Options
			'On':'Ein',
			'Off':'Aus',
			'Standard':'Standard',
			'Disable':'Deaktivieren',
			'iepe':'IEPE',
			'line':'Line',
			'horizontal':'1214/16/17 Horizontal',
			'vertical':'1214/16/17 Vertikal',
			'11octave':'1/1 Oktav',
			'13octave':'1/3 Oktav',
			'11wOctave':'1/1w Oktav',
			'13wOctave':'1/3w Oktav',
			'movingAverage':'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Mitternacht - 00h",
			'noon': "Mittag - 12h",
			'freeSpace': 'Speicherplatz SD-Karte: ',
			'instrumentSent': 'Nor140 eingestellt',
			'start':'Start',
			'stop':'Stop',
			'days':'Tage',
			'types':'Typen',
			'startstopActive':'Aktiv',
			'warningMeasRunning':'Einstellungen werden während einer laufenden Messung nicht übernommen!'
		},
		'video':{
			'settingsName':'Video',
			'Present':'Videokamera',
			'Manual':'Manuelle Aufzeichnung',
			'Triggering':'Überschreitungspegel Video',
			'Moving detection':'Bewegungserkennung',
			'Settings':'Einstellungen',
			'Pre':'Vor-Trigger',
			'Post':'Post-Trigger',
			'No device':'Keine Videokamera',
			'Video camera':'Videokamera',
			'SetDevice': 'Gerät einstellen',
			'formatSDWarning': 'Bitte warten Sie, bis die SD-Karte auf 100% steht',
		},
		'adio':{
			'settingsName':'ADIO',
			'Present':'ADIO',
			'ADIO':'ADIO Box',
			'NoDevice':'Kein ADIO',
			'DigitalOut':'Digital Out',
			'DigitalIn':'Digital In',
			'AnalogIn':'Analog In',
			'AnalogOut':'Analog Out',
			'AnalogLowerLimit':'Analog unteres Limit 0V/4mA',
			'AnalogUpperLimit':'Analog oberes Limit 10V/20mA',
			'Please input':'"Bitte eingeben"',
			//Options
			'On':'Ein',
			'Off':'Aus',
		},
		'norcloud':{
			'settingsName':'NorCloud',
			'IdNor':'Nor140 ID',
			'syncTime':'Aktualisierungsrate',
			'syncData': 'Pegel senden',
			'syncRec': 'Audio senden',
			'sendAlerts': 'Alarm senden',
			'recSett': 'Einstellungen empfangen',
			'applySett': 'Empfangene Einstellungen übernehmen',
			//Options
			'On':'Ein',
			'Off':'Aus',
			'disable':'Deaktivieren',
			'min':'min',
			'hour':'Stunde',
			'now': 'Wenn Einstellungen empfangen wurden',
			'fhour': 'Zur vollen Stunde',
			'break': 'Wenn Mikrofon Check durchgeführt wurde',
		},
		'statistics':{
			'settingsName':'Statistik',
			'reportSending':{
				'settingsName': 'Automatisches Senden von Berichten',
				'Name': 'Vorlage',
				'Title': 'Titel',
				'Duration': 'Berichtart',
				'Days': 'Senden am',
				'Hours': 'Senden um',
				'Range': 'Letzten Tage',
				'Email': 'E-Mail', 
				'Language':'Sprache'
			},
			'options': {
				'Range': 'Bereich',
				'Daily': 'Täglich',
				'On Event': 'Ereignis',
			}
		},
		'status':{
			'settingsName':'System',
			'Reboot':'System neu starten',
			'Reboot confirm': 'Möchten Sie das System wirklich neu starten?',
			'Reboot success': 'Weniger als 1 Minute bis zum Neustart!',
			'Reboot cancel': 'Neustart abgebrochen',
			'Restart confirm':'Möchten Sie den Nor140 wirklich neu starten?',
			'Restart Warning': 'Nor140 wird in 1min wieder online sein!',
			'Restart success': 'Nor140 online!',
			'Restart cancel': 'Abgebrochen',
			'Version':'Version',
			'Release':'Veröffentlichungsdatum',
			'PCFree':'PC Speicher [%]',
			'SDD':'SSD',
			'memory':'Speicher',
			'camera':'Videokamera SD-Karte',
			'n140':'Nor140 SD-Karte',
			'cpu':'CPU Leistung',
			'firmware':'Firmware',
			'logs':'Logs',
			'download':'Download',
			'total':'Gesamt',
			'free':'Frei',
			'used':'Belegt',
			'gbOrMore':'2GB oder mehr',
			'of':'of',
			'users': 'Benutzer',
			'username':'Benutzername',
			'password':'Passwort',
			'adminUsr': 'Admin',	
			'noiseUsr': 'Benutzer',
			'guestUsr': 'Gast'	
        	}
	},
	'errors':{
		'n140':'Nor140',
		'weather': 'Wetter',
		'adio': 'ADIO',
		'cameraSD':'Kamera SD-Karte über 80% voll!'
	},
	'codes':{
		"13":"Keine Serielle Verbindung",
		"16":"Software Optionen fehlen",
		"64":"OK - Kein Fehler",
		"89":"Messzeit zu lang für Synchro",
		"90":"Befehl Unbekannt",
		"91":"Option nicht verfügbar",
		"92":"I/O gesperrt",
		"93":"Keine Marker für die ausgewählte Datei",
		"94":"Befehlszeichenfolge zu lang ohne Trennzeichen",
		"97":"Geräte-Fehler",
		"99":"Kein DECT Modul gefunden",
		"100":"Keine Zahl gelesen",
		"101":"Zahl ist nicht zulässig",
		"102":"Text zu Lang",
		"104":"Keine gültigen Daten",
		"105":"Zahl ist außerhalb des Messbereichs",
		"106":"Messung nicht gestartet",
		"108":"Zeitüberschreitung auf String-Parameter zu einen Befehl",
		"109":"Software V2.X Option nicht installiert",
		"110":"Fehler im Textformat",
		"111":"Software V3.x Option nicht installiert",
		"112":"Speicher Voll",
		"116":"Alle Speichervorgänge blockiert aufgrund von Speicherfehlern",
		"117":"Audiometer Kalibrierung Fehler",
		"118":"Undefinierter Fehler",
		"119":"Undefinierter Fehler",
		"121":"Ordner nicht eingestellt",
		"122":"Ordner nicht gefunden",
		"123":"Speicherprüfung OK",
		"124":"SD-Karte nicht vorhanden",
		"125":"SD-Karte nicht unterstüzt",
		"126":"SD-Karte schreibgeschützt"
	}
}


// WEBPACK FOOTER //
// ./src/localization/translations/local-AT.js